<div id="progress-container">

  @if (!showCompletion) {
    <div class="progress">
      <div class="header">
        {{ header }}
      </div>
      @if (subHeader) {
        <div class="sub-header">
          {{ subHeader }}
        </div>
      }
      @if (message) {
        <div class="message">
          {{ message }}
        </div>
      }
      <div class="progress-bar-wrapper">
        @if (!indeterminate) {
          <app-shared-progress-bar
            [current]="progress * 100"
            [total]="100"
            [showFraction]="false"
            [showPercent]="false">
          </app-shared-progress-bar>
        } @else {
          <app-shared-progress-bar
            [total]="null"
            [showFraction]="false"
            [showPercent]="false">
          </app-shared-progress-bar>
        }
        @if (!indeterminate && showPercentage) {
          <i>{{ (progress * 100).toFixed(2) }}%</i>
        }
      </div>
    </div>
  } @else {
    @if (showCompletion === 'success') {
      <div class="complete">
        <div class="sub-header">
          {{ completion }}
        </div>
        <div class="buttons">
          <app-shared-button (buttonClicked)="onClose()" [fill]="true" [colour]="'secondary'">
            {{ okButton }}
          </app-shared-button>
        </div>
      </div>
    } @else {
      <div class="failed">
        <div class="sub-header">
          {{ completion }}
        </div>
        <div [class]="'buttons' + (retry ? ' bts2' : '')">
          <app-shared-button (buttonClicked)="onClose()" [fill]="true" [colour]="'secondary'">
            {{ okButton }}
          </app-shared-button>
        </div>
      </div>
    }
  }


</div>
